import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import call from 'src/assets/images/call.svg'
import claims from 'src/assets/images/claims.svg'
import { INSURANCE_DETAILS } from 'src/utils/constants/InsuranceDetails'

const AllClaims = () => {
  const classes = useStyles()
  return (
    <div className={classes.allClaimsContainer}>
      <div className={classes.claimDiv}>
        <div className={classes.topTextDiv}>
          <p className={classes.topText} data-test='claimText'>
            We are building a constructive plan to support you with the
            end-to-end claim process.{' '}
          </p>
        </div>
        <div className={classes.claimsImageContaier}>
          <img
            src={claims}
            className={classes.claimsImage}
            alt='Claims'
            data-test='claimImage'
          />
        </div>
        <div className={classes.bottomTextDiv}>
          <p className={classes.bottomText} data-test='bottomText'>
            However, reach out to us for any instant claim assistance.{' '}
          </p>
        </div>
        <div className={classes.phoneDiv}>
          <img src={call} className={classes.phoneImage} alt='Phone' />
          <p className={classes.phoneNumber} data-test='phone'>
            {INSURANCE_DETAILS?.HELP_MOBILE}
          </p>
        </div>
      </div>
    </div>
  )
}

export default AllClaims

const useStyles = makeStyles({
  buttonUploadPersonal: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.WHITE,
    color: COLORS.MEDIUM_LIGHTBLUE,
    // margin: "-4px 0 10px 9px",
    height: '24px',
    padding: '15px 20px !important',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: COLORS.WHITE,
    },
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
  },
  phoneNumber: {
    margin: '0px 0px',
    color: COLORS.DARK_PINK,
    fontSize: '14px',
  },
  phoneImage: {
    width: '23px !important',
    paddingRight: '10px',
  },
  phoneDiv: {
    padding: '0px 0px 30px 0px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  bottomText: {
    margin: '0px 0px',
    color: COLORS.GREY,
    fontSize: '14px',
  },
  bottomTextDiv: {
    padding: '10px 0px 5px 0px',
    textAlign: 'center',
  },
  topText: {
    margin: '0px 0px',
    color: '#6A6A6A',
    padding: '0px 150px',
  },
  topTextDiv: {
    padding: '30px 0px 25px 0px',
    textAlign: 'center',
  },
  claimDiv: {
    width: '50vw !important',
    backgroundColor: 'white',
    borderRadius: '20px',
  },
  claimsImageContainer: {
    padding: '0px 0px',
    textAlign: 'center',
  },
  claimsImage: {
    width: '45% !important',
  },
  allClaimsContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
})
